import { STRINGS } from '../../constants';
import apiCaller from '../http';
import URLS from '../urls';

const searchEmployees = async (value, setEmployeesList, setError, logoutHandler) => {
  await apiCaller
    .get(`${URLS.EMPLOYEES_BY_QUERY}${value}`)
    .then((resp) => {
      setError(null);
      setEmployeesList(resp.data);
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
    });
};

export default searchEmployees;
